import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA,MatDialog } from '@angular/material/dialog';
import { Configuration } from 'src/app/models/configurations/configuration';
import { ConfigurationApplicationStatus, ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { Constants } from 'src/app/models/constants';
import { ErrorDialogJarComponent } from 'src/app/components/error-dialog-jar/error-dialog-jar.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-configuration-details',
    templateUrl: './configuration-details.component.html',
    styleUrls: ['./configuration-details.component.scss'],
    standalone: false
})
export class ConfigurationDetailsComponent {

  configuration: Configuration;
  results: boolean;
  Constants = Constants;
  ConfigurationPackageStatus = ConfigurationApplicationStatus;
  configurationState: ConfigurationState;
  isRvt = false;
  @Output() actionPerformed = new EventEmitter<any>();


  constructor(@Inject(MAT_DIALOG_DATA) private data: any,private sidenavService: SidenavService,
  public matdialogRef: MatDialogRef<ConfigurationDetailsComponent>, private dialog: MatDialog) {
    this.configuration = data.configuration;
    this.results = data.results;
    this.configurationState = data.configurationState;
    this.isRvt = data?.isRvt;
  }

  actionClick(type, configuration, resultsReportFile): void {
    const data: any = {
      type,
      configuration,
      resultsReportFile
    };
    this.actionPerformed.emit(data);
  }

  configPackErrorDetails(packageError, titleName, jarName){
    this.dialog.open(ErrorDialogJarComponent, {
            panelClass: 'right-dialog-panel',
            disableClose: false,
            hasBackdrop: true,
            data: {
              title:  titleName,
              jarName: jarName,
              description: packageError,
            }
          });

  }
}
